import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AgreementService from "../../Controller/AgreementController"
import { handleChange, handleSubmit } from "../../Controller/UpdateAgreementNotesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import SunTextEditor from "../../../Common/SunTextEditor";
import { quillModules, quillFormats, addToolbarTitles } from "../../../Common/quillConfig";
function AgreementNotes({ AgreementID }) {
    AgreementID = localStorage.getItem('AgreementID');
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const [formData, setFormData] = useState({ contractDetails: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    const fetchAgreementNotes = async () => {
        try {
            const data = await AgreementService.GetAgreementByID(redirectCallback, AgreementID);
            debugger;

            if (data[0].FK_Issue_ID > 0 || data[0].FK_SalesOrder_ID > 0) {
                SetIsClosed("1");
            }

            if (data && data.length > 0) {
                setFormData(data[0]);
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };
    useEffect(() => {
        SetIsClosed("0");
        if (AgreementID > 0) {
            fetchAgreementNotes();
        }
    }, [AgreementID]);


    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            contractDetails: content
        });
    };

    const handleFormSubmit = async (event) => {
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        formData.ContractID = AgreementID;
        const message = await handleSubmit(event, formData, setFormData, setErrors);
        if (message == "Data saved successfully") {
            setShowSuccessMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
        }
        else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);

        }
        fetchAgreementNotes();
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "0px" }}>
                <div className="col-xl-12" style={{ "textAlign": "right" }}>
                   
                </div>
            </div>
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "0px" }}>
                    <label htmlFor="contractDetails" className="col-sm-1 col-form-label">Notes:</label>
                    <div className="col-sm-11">
                        <SunTextEditor
                            value={formData.contractDetails}
                            onChange={(content) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    contractDetails: content,
                                }))
                            }
                        />
                        {errors.contractDetails && <div style={{ color: 'red' }}>{errors.contractDetails}</div>}
                    </div>
                </div>
                <div className="row" style={{ "marginLeft": "0px", "float": "right", "marginRight": "0px" }}>
                    <div className="col-sm-12">
                        <button type="submit" className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                           <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                           
                        </button>

                    </div>
                </div>
            </form>
        </div>
    );
}
export default AgreementNotes;